/* STORIA bilingual text direction manager.
   Any text containing Hebrew/Arabic uses an RTL paragraph base; Latin-only text uses LTR.
   This keeps brand names, numbers and punctuation stable inside Hebrew sentences. */
(() => {
  const SELECTOR = [
    'h1','h2','h3','h4','h5','h6','p','blockquote','figcaption','li','dt','dd','label','legend','summary','button','a',
    '.rte > *','[class*="heading"]','[class*="title"]','[class*="subtitle"]','[class*="text"]','[class*="description"]','[class*="caption"]','[class*="label"]'
  ].join(',');
  const SKIP = 'script,style,code,pre,svg,math,input,textarea,select,option,[contenteditable="true"],[data-no-auto-dir]';
  const RTL_RE = /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;

  function setDirection(el) {
    if (!el || el.matches?.(SKIP) || el.closest?.('code,pre,svg,math,[data-no-auto-dir]')) return;
    const text = (el.textContent || '').trim();
    if (!text) return;
    const dir = RTL_RE.test(text) ? 'rtl' : 'ltr';
    el.setAttribute('dir', dir);
    el.dataset.textDir = dir;
  }

  function apply(root = document) {
    const nodes = root.nodeType === 1 && root.matches?.(SELECTOR)
      ? [root, ...root.querySelectorAll(SELECTOR)]
      : [...(root.querySelectorAll?.(SELECTOR) || [])];
    nodes.forEach(setDirection);
  }

  function start() {
    apply(document);
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') setDirection(record.target.parentElement);
        for (const node of record.addedNodes) if (node.nodeType === 1) apply(node);
      }
    });
    observer.observe(document.body, {subtree:true, childList:true, characterData:true});
    document.addEventListener('shopify:section:load', e => apply(e.target));
    document.addEventListener('shopify:block:select', e => apply(e.target));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
